import React from "react";

const MatchIcon = ({ size = 24, className = "", active = false, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_619_54617)">
        <foreignObject x="-9.05275" y="-9.05275" width="50.1055" height="50.1055">
          <div xmlns="http://www.w3.org/1999/xhtml" style={{ backdropFilter: "blur(4.53px)", clipPath: "url(#bgblur_1_619_54617_clip_path)", height: "100%", width: "100%" }}></div>
        </foreignObject>
        <rect 
          data-figma-bg-blur-radius="9.05275" 
          x="0.5" 
          y="0.5" 
          width="31" 
          height="31" 
          rx="11.5" 
          fill={active ? "#37ED64" : "#9EA6B2"} 
          fillOpacity="0.3" 
          stroke="url(#paint0_linear_619_54617)"
        />
        <path 
          d="M22.9979 13.6349L15.6657 21.3323C15.466 21.5419 15.226 21.7091 14.9602 21.8239C14.6944 21.9386 14.4081 21.9985 14.1186 22H14.1093C13.8214 22 13.5365 21.9422 13.2714 21.8301C13.0062 21.718 12.7663 21.5538 12.5658 21.3473L8.67623 17.3401C8.46471 17.1409 8.29574 16.9008 8.17953 16.6344C8.06332 16.3681 8.00227 16.0809 8.00006 15.7903C7.99786 15.4997 8.05454 15.2117 8.1667 14.9436C8.27886 14.6755 8.44416 14.4329 8.65264 14.2304C8.86111 14.028 9.10844 13.8698 9.3797 13.7656C9.65097 13.6613 9.94054 13.6131 10.231 13.6238C10.5214 13.6345 10.8066 13.7039 11.0695 13.8279C11.3323 13.9518 11.5673 14.1277 11.7603 14.345L14.0913 16.747L19.8787 10.6692C20.0734 10.4644 20.3066 10.2999 20.5649 10.1852C20.8231 10.0705 21.1015 10.0078 21.384 10.0007C21.6665 9.99356 21.9477 10.0421 22.2114 10.1437C22.4752 10.2452 22.7164 10.3977 22.9212 10.5924C23.126 10.7872 23.2904 11.0203 23.4051 11.2786C23.5198 11.5369 23.5825 11.8153 23.5897 12.0978C23.5968 12.3803 23.5482 12.6615 23.4467 12.9252C23.3451 13.189 23.1926 13.4301 22.9979 13.6349Z" 
          fill={active ? "#37ED64" : "#37ED64"}
        />
      </g>
      <defs>
        <clipPath id="bgblur_1_619_54617_clip_path" transform="translate(9.05275 9.05275)">
          <rect x="0.5" y="0.5" width="31" height="31" rx="11.5"/>
        </clipPath>
        <linearGradient id="paint0_linear_619_54617" x1="2.25884" y1="2.51674" x2="29.0078" y2="31.1176" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <clipPath id="clip0_619_54617">
          <rect width="32" height="32" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default MatchIcon; 